export const enableButton = (button) => {
    button.classList.remove('active');
    button.removeAttribute('disabled');
};

export const disableButton = (button) => {
    button.setAttribute('disabled', '');
};
